import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom';
import { AccessDashboard, ViewSharedReports } from "pageComponents";
import { mrSitesReportsGetByReportID } from 'apiServices/reducer/apiService';


const AccessLandingPage = (props) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const menuData = useSelector((state) => state.apiService.sharedReportsValidateCode);
    const token = useSelector((state) => state.apiService.token);
    const userData = useSelector((state) => state.apiService.login);

    const userId = menuData?.user_id;
    const isExternalUser = menuData?.is_external_user || false;
    const accessType = menuData?.access_type || '';
    const isAccess = menuData?.role === 'User';
    const [tab, setTab] = useState('');
    const [PDFURL, setPDFURL] = useState(null);
    const [selectedReportID, setSelectedReportID] = useState(null);
    const [isReportPreviewLoading, setIsReportPreviewLoading] = useState(false);
    useEffect(() => {
        console.log("access props", props.activeMenuItem)
        if (props.activeMenuItem.showAccessDashboard) {
            setTab("All");
            setSelectedReportID(null);
            setPDFURL(null);
            setIsReportPreviewLoading(false);
        }
    }, [props.activeMenuItem])

    const setLogUserMenuAnalytics = (event, boolean) => {
        console.log("props.activeMenuItem", props.activeMenuItem)
        console.log("event reports data", event)
        console.log("boolean", boolean)
        const reportId = event.reportId;
        const params = {
            ReportID: reportId,
            UserID: userId,
            token: token
        }

        // Set the tab to the category name from the event
        setTab(event.label);

        if (props.activeMenuItem && props.activeMenuItem.showAccessDashboard === true) {
            // Use the setter function to properly update state
            props.setActiveMenuItem(prev => ({
                ...prev,
                showAccessViewSharedReports: true,
                showAccessDashboard: false,
                showDashBoard: false
            }));

            // Update navigation state to highlight the reports menu item
            if (props.setActiveMenuItems) {
                props.setActiveMenuItems({ menu_id: 9, parent_id: null });
            }

            console.log("props.activeMenuItem", props.setActiveMenuItem)
            console.log("Switched to ViewSharedReports with tab:", event.label)
        }
        else if (props.activeMenuItem && props.activeMenuItem.showAccessViewSharedReports === true) {
            // Use the setter function to properly update state
            props.setActiveMenuItem(prev => ({
                ...prev,
                showAccessViewSharedReports: false,
                showAccessDashboard: true,
                showDashBoard: false
            }));

            // Update navigation state to highlight the dashboard menu item
            if (props.setActiveMenuItems) {
                props.setActiveMenuItems({ menu_id: 1, parent_id: null });
            }

            console.log("props.activeMenuItem", props.setActiveMenuItem)
            console.log("Switched to Dashboard")
        }

        if (boolean) {
            setIsReportPreviewLoading(true);
            setPDFURL(null);
            dispatch(mrSitesReportsGetByReportID(params)).then(response => {
                console.log("response from mrSitesReportsGetByReportID", response)
                const resp = response.payload;
                const blobUrl = URL.createObjectURL(resp);
                console.log('Created blob URL:', blobUrl);
                setPDFURL(blobUrl);
                setSelectedReportID(reportId);
            }).catch(error => {
                console.error('Error fetching report:', error);
                setPDFURL(null);
            }).finally(() => {
                setIsReportPreviewLoading(false);
            })
        }
    }

    useEffect(() => {
        console.log("activeMenuItem changed:", props.activeMenuItem);
    }, [props.activeMenuItem, props.setActiveMenuItem]);

    useEffect(() => {
        if (props.activeMenuItem?.showAccessViewSharedReports) {
            // This will run AFTER the state is updated and the component re-renders
            console.log("Now in View Shared Reports mode!");
        }
    }, [props.activeMenuItem?.showAccessViewSharedReports]);


    return (
        <>
            <div className='container-fluid mt-5 px-3'>
                {props.activeMenuItem?.showAccessDashboard && (
                    <div className='py-3'>
                        <AccessDashboard
                            userID={userId}
                            isExternalUser={isExternalUser}
                            accessType={accessType}
                            isAccess={isAccess}
                            isProvider={false}
                            token={token}
                            userData={userData}
                            location={location}
                            navigate={navigate}
                            setLogUserMenuAnalytics={(event, boolean) => setLogUserMenuAnalytics(event, boolean)}
                            tab={tab}
                        />
                    </div>
                )}

                {props.activeMenuItem?.showAccessViewSharedReports && (
                    <div className='py-3'>
                        <ViewSharedReports
                            userId={userId}
                            isExternalUser={isExternalUser}
                            accessType={accessType}
                            isAccess={isAccess}
                            activeTabfromUserAnalytics={tab}
                            PDFURL={PDFURL}
                            selectedReportIDIndex={selectedReportID}
                            isReportPreviewLoadingFromParent={isReportPreviewLoading}
                            OnclearPDF={() => {
                                setPDFURL(null);
                                setSelectedReportID(null);
                                setIsReportPreviewLoading(false);
                            }}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default AccessLandingPage;
